import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import Facebook from 'containers/SocialLogin/Facebook/Facebook';
import Twitter from 'containers/SocialLogin/Twitter/Twitter';
import LinkedIn from 'containers/SocialLogin/LinkedIn/LinkedIn';
import Google from 'containers/SocialLogin/Google/Google';
//import { facebook_get_access_token_api, HeaderConfig, user_authentication, twitter_api,user_API,myHeaders_Auth_With_Cache_Control } from 'Api/Api';
import { facebook_get_access_token_api, HeaderConfig, user_authentication, twitter_api } from 'Api/Api';
import './style.css';

import Button from 'components/Button/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from 'Assets/loginLogo.svg';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import axios from 'axios';
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup';
import { saveKey } from "utils/Helper";
import Footer from 'components/Footer/Footer';
import { origin } from 'utils/Helper';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
import { getQueryString } from "utils/Helper";
import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

//import { LinkedInPopUp } from 'react-linkedin-login-oauth2';

class Login extends Component {
    static contextType = UserContext;
    
    constructor(props) {
        super(props);
        this.state = {
            Auth_Res: '',
            user: null,
            type: 'password',
            wording: <i className="fa fa-eye"></i>,
            value: '',
            email: null,
            password: null,
            loader: true,
            ModalLoader: false,
            errors: {
                email: '',
                password: '',
            },
            validated: false,
            InvalidMsg: 0,
            originData:null
        };
        this.state.originData = window.localStorage.getItem('loginOrigin');
        
        
    }


    // getUserFbData will facebook_get_access_token_api
    getUserFbData = (userData) => {
        console.log("LOGIN getUserFbData",userData);
        const { originData } = this.state;
        let resData = userData[0];
        let access_obj = { "access_token": resData.accessToken }
        const Json_access_Obj = JSON.stringify(access_obj);
        axios.post(facebook_get_access_token_api, Json_access_Obj, HeaderConfig)
            .then((response) => {
                let resData=response.data;
                let UserData = { "UserMail": null, "login_Auth_Res": resData }
                saveKey("UserData", JSON.stringify(UserData));
                if (this.state.originData) {
                    if (this.state.originData === "pkCreation") {
                        window.localStorage.removeItem('loginOrigin');
                        window.location.href = `${local_routes.pkcreation}`;
                    } else {
                        // redirect back to loginOrigin
                        window.localStorage.removeItem('loginOrigin');
                        window.location.href = this.state.originData;
                    }
                } else {
                    window.location.href = origin;
                }
            })
            .catch(() => {
            });
    }


    // Api calls
    async componentDidMount () {
        this.context.setUserInfo({});
        //let originData = localStorage.getItem('loginOrigin');
        // console.log("userLoginOrigin",ch)
        //this.setState({ loader: true,originData:originData })
        console.log("LOGIN componentDidMount",this.props.location);
        const oauth_token = getQueryString('oauth_token');
        const oauth_verifier = getQueryString('oauth_verifier');

        // handle Twitter callback here
        if (oauth_token && oauth_verifier) {
            //this.setState({ loader: true })
            try {
                let response = await axios.post(twitter_api, { oauth_token, oauth_verifier }, HeaderConfig);
                let data2 = { "UserMail": "", "login_Auth_Res": response.data }
                saveKey("UserData", JSON.stringify(data2));
                if (this.state.originData) {
                    if (this.state.originData === "pkCreation") {
                        window.localStorage.removeItem('loginOrigin');
                        window.location.href = `${local_routes.pkcreation}`;
                    } else {
                        // redirect back to loginOrigin
                        window.localStorage.removeItem('loginOrigin');
                        window.location.href = this.state.originData;
                    }
                } else {
                    window.location.href = origin;
                }
                return;
            } catch (err) {
                // twitter login failed?
            }
        }
        this.setState({ loader: false });
    }

    // changeState is for password toggle validation.
    changeState = () => {
        var oldState = this.state.type;
        var isTextOrHide = (oldState === 'password');
        var newState = (isTextOrHide) ? 'text' : 'password';
        var newWord = (isTextOrHide) ? <i className="fa fa-eye-slash" aria-hidden="true"></i> : <i className="fa fa-eye"></i>;
        this.setState({
            type: newState,
            wording: newWord
        })
    }

    // Form Validation
    myChangeHandler = (event) => {
        if (event.target.id === "validationEmail") {
            this.setState({ email: event.target.value })
        }
        else if (event.target.id === "validationPassword") {
            this.setState({ password: event.target.value })
        }
    }

    // Form SubmitData
    handleSubmitData = event => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (form.checkValidity() !== false) {
            event.preventDefault();
            const { email, password,originData } = this.state;
            this.setState({ ModalLoader: true })
            let loginData = { "email": email, "password": password }
            axios.post(user_authentication, loginData, HeaderConfig)
                .then((response) => {
                    let resData=response.data;
                    let UserData = { "UserMail": null, "login_Auth_Res": resData }
                    saveKey("UserData", JSON.stringify(UserData));
                    if (originData) {
                        if (originData === "pkCreation") {
                            window.localStorage.removeItem('loginOrigin');
                            window.location.href = `${local_routes.pkcreation}`;
                        } else {
                            // redirect back to loginOrigin
                            window.localStorage.removeItem('loginOrigin');
                            window.location.href = originData;
                        }
                    } else {
                        window.location.href = origin;
                    } 
                    
                })
                .catch(() => {
                    this.setState({ ModalLoader: false, InvalidMsg: 1, })
                });
        }
        this.setState({ validated: true })
    };
    
    //  Page Navigation
    SignUpPK = () => {
        // JBB - we only want to redirect back to pkCreation when people click 'Get Started' on PKCreateHome
        //localStorage.setItem('loginOrigin', "pkCreation");
        this.props.history.push("/register");
    }
    
    resetPassword = () => {
        this.props.history.push("/resetpassword");
    }
    
    render() {
        const { ModalLoader, loader } = this.state;
        if (loader) {
            return (
                <FullPageSpinner />
            )
        }
        else {
            return (
                <React.Fragment>
                <Helmet>
                    <title>PechaKucha Login</title>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <div className="login-footer">
                    <div className="Register-grid">
                        <Row className="nomargin flex-center" >
                            <Col lg={2} md sm/>
                            <Col lg={8}>
                                <div className="flex-center logo-container">
                                    <a href="/"><img src={logo} alt="img" className="img-fluid navbar-brand img-logo" /></a>
                                </div>
                                <div className="Register-Form">
                                    <Row>
                                        <Col xl={5} lg={6} md={6} sm={6} xs={12} className="noPadding pad-l">
                                            <div className="Register-body">
                                                <p>Login</p>
                                                <div className="social-login">
                                                    <div className="twitter">
                                                        <Twitter {...this.props} callbackUrl="/login" />
                                                    </div>
                                                    <div className="facebook">
                                                        <Facebook ongetUserFbData={this.getUserFbData} />
                                                    </div>
                                                    <div className="linkedin">
                                                        <LinkedIn />
                                                    </div>
                                                    <div className="google">
                                                        <Google />
                                                    </div>
                                                </div>
                                                {/* Border */}
                                                <div className="border-style"></div>
                                                <div className="Form-section">
                                                    <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmitData}>
                                                        <Form.Row>
                                                            <Form.Group as={Col} md="12" controlId="validationEmail">
                                                                <Form.Label>E-MAIL ADDRESS</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    type="email"
                                                                    placeholder="Enter your email"
                                                                    onChange={this.myChangeHandler}
                                                                />
                                                            </Form.Group>
                                                        </Form.Row>
                                                        <Form.Row>
                                                            <Form.Group as={Col} md="12" controlId="validationPassword">
                                                                <Form.Label>PASSWORD
                                                                    <InputGroup>
                                                                        <Form.Control
                                                                            type={this.state.type}
                                                                            placeholder="Enter your password"
                                                                            aria-describedby="inputGroupPrepend"
                                                                            required
                                                                            onChange={this.myChangeHandler}
                                                                        />
                                                                        <span className="password-trigger" onClick={this.changeState}>{this.state.wording}</span>
                                                                    </InputGroup>
                                                                </Form.Label>
                                                            </Form.Group>
                                                        </Form.Row>
                                                        <div style={{ display: this.state.InvalidMsg === 0 ? "none" : null }} className="Invalid-section">
                                                            <span className="Invalid-Msg">Invalid Username/Password</span>
                                                        </div>
                                                        <div>
                                                            {
                                                                ModalLoader === false ?
                                                                    <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5">Login</Button>
                                                                    :
                                                                    <ActivityIndicator theme="button-Status-Loader" />
                                                            }
                                                        </div>
                                                    </Form>
                                                </div>
                                                {/* Border */}
                                                <div className="border-style"></div>
                                                <Button theme="btn-global btn-white width100 Form_Btn_Pad font-normal" OnClickMet={this.SignUpPK}>Create Account</Button>
                                            </div>
                                        </Col>
                                        <Col xl={7} lg={6} md={6} sm={6} className="noPadding pad-r d-none d-lg-block d-md-block d-sm-block d-xs-none " >
                                            <div className="Login-Img-sec" >
                                                <div className="login_img-body">
                                                    <h5 className="welcome-msg">Welcome (back) to PechaKucha</h5>
                                                    <p className="Pecha-info">PechaKucha is about presenting about what you love. Anyone can present -- this is the beauty of PechaKucha.</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="flex-center Forget-password">
                                    <p >Forget your password? <a href={local_routes.sendresetpasswordemail}>Get a new password</a></p>
                                </div>
                            </Col>
                            <Col lg={2} md sm />
                        </Row>

                    </div>
                    <Footer />
                </div>
                </React.Fragment>
            );
        }
    }
}

export default Login;